import { render } from "./ManualUnderwritingTab.vue?vue&type=template&id=8fa240e8&ts=true"
import script from "./ManualUnderwritingTab.vue?vue&type=script&lang=ts"
export * from "./ManualUnderwritingTab.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__